module.exports = __webpack_public_path__ + "img/hero-sass-bg.326e4f9b.jpg";